import  {z} from "zod";

export class ResolutionToday {

    public static getTodayStringFromDays(days: number | false): string {
        if (days===false) {
            return '';
        }
        days = Math.floor(days);
        return 'today:' + days;
    }

    public static isValidTodayString(strValue: string): boolean {
        return strValue.indexOf('today:') === 0 || strValue === '';
    }

    public static getDaysFromTodayString(strValue: string): number|false {
        if (strValue=== '') {
            return false;
        }
        return z.coerce.number().catch(7).parse(strValue.replace('today:', ''));
    }

}